module.exports = __webpack_public_path__ + "img/goyoga-manager-simplifier-gestion-activite.b73be02.jpeg";